<script lang="ts">
import GenericModal from "@/Components/Generics/GenericModal.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        GenericModal,
    },
    props: {
        title: {
            type: String,
            default: "No_title",
        },
        extra: {
            type: String,
            default: "_desc",
        },
    },
    emits: [],
    data: () => ({
        modalOpen: false,
    }),
    computed: {},
    methods: {
        openModal() {
            this.modalOpen = true;
        },
        closeModal() {
            this.modalOpen = false;
        },
    },
});
</script>

<template>
    <div class="help-button" @click.stop="openModal">
        <span class="question-mark text text--accent-gray-a text--size-27 text--medium">?</span>

        <GenericModal v-if="modalOpen" @closed="closeModal">
            <template #title>{{ $trans(title) }}</template>
            <template #content>
                <div class="flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center">{{ $trans(title + extra) }}</div>
            </template>
        </GenericModal>
    </div>
</template>

<style lang="scss" scoped>
.help-button {
    display: block;
    position: relative;
    height: rem(36);
    aspect-ratio: 1;
    border-radius: 50%;
    border: solid $color-accent-light-a rem(4);
    background-color: #fff;
    cursor: pointer;

    transition:
        border-color 0.05s ease-in-out,
        background-color 0.05s ease-in-out;

    &:hover {
        border-color: $color-accent-light-b;
        background-color: $color-accent-light-a;

        .question-mark {
            color: #fff;
        }
    }

    .question-mark {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;

        transition: color 0.05s ease-in-out;
    }
}

@include media-breakpoint-down(xxl) {
    .help-button {
        .question-mark {
            transform: translate(-50%, calc(-50% + #{rem(1)}));
        }
    }
}
@include media-breakpoint-down(md) {
    .help-button {
        height: rem(33);
    }
}
@include media-breakpoint-down(sm) {
    .help-button {
        height: rem(30);

        .question-mark {
            transform: translate(-50%, calc(-50% + #{rem(2)}));
        }
    }
}
</style>
